export const INIT_FORM_DATA = {
  //Your Details
  brideFullName: "",
  brideEmail: "",
  bridePhone: "",
  brideNationality: "",
  brideAge: "",
  groomFullName: "",
  groomEmail: "",
  groomPhone: "",
  groomNationality: "",
  groomAge: "",
  //Your Budget
  spendingPriority: "",	 
  spendingPriorityOtherDescription: "",
  weddingBudget: "", 
  weddingBudgetOtherDescription: "", 
  budgetNotes: "",
  //Vendors & Collaborators
  vendorsAndCollaborators: "",
  // Wedding Style & Aesthetic
  vision: "",
  visionOtherDetails: "",
  colorPalette: "",
  colorPaletteOtherDetails: "",
  florals: "",
  floralsOtherDetails: "",
  //Event Details
  primaryDate: "",
  alternativeDates: "",
  estimatedGuests: "",
  childFriendly: "",
  timeOfDay: "",
  ceremonyType: "",
  ceremonyOther: "",
  venueType: "",
  venueLocation: "",
  venueName: "",
  venueDetails: "",
}

export const QUESTIONNAIRE_SUCCESS_TEXT = "Thank you so much for taking the time to complete this questionnaire";

export const MAIN_AND_OTHER_FIELDS = [
  { main: "ceremonyType", other: "ceremonyOther" },
  { main: "spendingPriority", other: "spendingPriorityOtherDescription" },
  { main: "weddingBudget", other: "weddingBudgetOtherDescription" },
  { main: "vision", other: "visionOtherDetails" },
  { main: "colorPalette", other: "colorPaletteOtherDetails" },
  { main: "florals", other: "floralsOtherDetails" },
];

export const OPTIONAL_FIELDS = ["budgetNotes", "venueDetails", "venueLocation", "venueName", "alternativeDates",];